import { render, staticRenderFns } from "./addApi.vue?vue&type=template&id=894abd96"
import script from "./addApi.vue?vue&type=script&lang=js"
export * from "./addApi.vue?vue&type=script&lang=js"
import style0 from "./addApi.vue?vue&type=style&index=0&id=894abd96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports